import {
    reduxActions,
    fetchTypes,
    requestStatus
} from '../constants';
import { ReportChartAdapter } from '../utils';

const defaultState = {
    'currentPageNumber': 1,
    'pageSize': 20,
    'results': [],
    'totalItemCount': 0,
    'totalPageCount': 0,
    'searchParams': {}
};

export function completedReports(state = defaultState, action) {
    if (action.fetchType === fetchTypes.REPORT_SEARCH) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_SET_SEARCH_PARAMS:
                return Object.assign({}, state, {
                    searchParams: action.searchParams
                })
        }
    }

    return state;
}

export function pendingSamples(state = defaultState, action) {
    if (action.fetchType === fetchTypes.PENDING_REPORT_SEARCH) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_SET_SEARCH_PARAMS:
                return Object.assign({}, state, {
                    searchParams: action.searchParams
                })
        }
    }

    return state;
}

export function reportAccess(state = defaultState, action) {
    if (action.fetchType === fetchTypes.REPORT_ACCESS) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    searchParams: (action.request.payload) ? action.request.payload : {}
                });
            case reduxActions.RESOURCE_SET_SEARCH_PARAMS:
                return Object.assign({}, state, {
                    searchParams: action.searchParams
                })
        }
    }

    return state;
}

const downloadStatus = {
    status: undefined,
    error: false,
    progress: requestStatus.INACTIVE,
    isLoading: false
}

export function completedReportSearchExport(state = downloadStatus, action) {
    if (action.fetchType === fetchTypes.COMPLETED_REPORT_SEARCH_EXPORT) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    isLoading: true
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress,
                    isLoading: false
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    isLoading: false
                });
        }
    }

    return state;
}

export function pendingReportSearchExport(state = downloadStatus, action) {
    if (action.fetchType === fetchTypes.PENDING_REPORT_SEARCH_EXPORT) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    isLoading: true
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress,
                    isLoading: false
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    isLoading: false
                });
        }
    }

    return state;
}

const defaultReportData = {
    chartAdapter: {
        charts: []
    }
};

export function reportData(state = defaultReportData, action) {
    let chartAdapter;

    if (action.fetchType === fetchTypes.REPORT_DATA) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                chartAdapter = new ReportChartAdapter(action.payload, {
                    fill: false
                });
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    chartAdapter: chartAdapter
                });
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./web-app/reducers/report-reducer.js